import { Http } from '@angular/http';
import { Injectable } from '@angular/core';
import { ParentService } from 'app/pages/A2-utils/ParentClass/ParentService';
import { constant } from 'app/app.constants';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class UpdateDriversScheduleService extends ParentService {

  constructor(private http: Http) {
    super();
  }

  getDriverSchedule(idDriver: number) {
    const url = `${constant.DRIVER.MCT_DRIVER.DRIVER_SCHEDULE}/${idDriver}`;
    return this.http.get(url, this.getHeader())
    .map(response => response.json())
    .catch(error => Observable.throw(error.json()));
  }

  updateDriverSchedule(data) {
    const url = `${constant.DRIVER.MCT_DRIVER.UPDATE_DRIVER_SCHEDULE}`;
    return this.http.put(url, data, this.headerPost())
    .map((res) => res.json())
    .catch(error => Observable.throw(error.json()));
  }

}



// WEBPACK FOOTER //
// ./src/app/utils/update-drivers-schedule/update-drivers-schedule.service.ts